import axios from "../config/authaxios";

let cachedCountries = null;
let fetchPromise = null;

export const getCountries = async () => {
  if (cachedCountries) {
    return cachedCountries;
  }

  if (fetchPromise) {
    return fetchPromise;
  }

  fetchPromise = axios
    .get("/admin/countries")
    .then((res) => {
      cachedCountries = res.data?.response ?? res.data ?? [];
      return cachedCountries;
    })
    .catch((err) => {
      fetchPromise = null;
      throw err;
    });

  return fetchPromise;
};

export const getCountryId = (country) => {
  if (!country) return "";
  if (typeof country === "string") return country;
  if (Array.isArray(country)) return country[0]?._id ?? "";
  return country._id ?? "";
};

export const getCountryName = (country) => {
  if (!country) return "—";
  if (Array.isArray(country)) return country[0]?.name ?? "—";
  if (typeof country === "object") return country.name ?? "—";
  return "—";
};
